import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import ReportMonthly from "./ReportMonthly";
import styles from "./styles";
import { AppState } from "../../redux/store";
import { monthlyReportRequest } from "../../redux/actions/reports";
import { setFilter } from "../../redux/actions/filter";
import {
  selectMonthlyReportData,
  selectMonthlyReportErrorState,
  selectMonthlyReportLoadingState
} from "../../redux/selectors/reports";

const mapStateToProps = (state: AppState) => ({
  monthlyReport: selectMonthlyReportData(state),
  loading: selectMonthlyReportLoadingState(state),
  error: selectMonthlyReportErrorState(state)
});

const mapDispatchToProps = {
  loadMonthlyReport: monthlyReportRequest,
  setFilterState: setFilter
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ReportMonthly)
);
